import { useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Descricao from "./Etapas/Descricao";
import { PlanoDeTrabalho } from "../../model/PlanoDeTrabalho";
import ExecucaoFisico from "./Etapas/Execucao/ExecucaoFisico";
import {
  MetaAplicacao,
  MetaFisica,
} from "../../model/PlanoDeTrabalho/CronogramaExecucao";
import {
  MetaAplicacaoRecurso,
  ReceitaDespesa,
} from "../../model/PlanoDeTrabalho/PlanoAplicacao";
import { Equipamento } from "../../model/PlanoDeTrabalho/AquisicaoDeEquipamentos";
import AplicacaoFinanceira from "./Etapas/Execucao/AplicacaoFinanceira";
import AplicacaoRecurso from "./Etapas/AplicacaoRecurso";
import ReceitasDespesas from "./Etapas/ReceitasDespesas";
import deconvertCalendario from "../../services/deconvertCalendario";
import Equipamentos from "./Etapas/Equipamentos/Equipamentos";

type Props = {
  descricao: PlanoDeTrabalho;
  metaFisica: MetaFisica[];
  metasAplicacoes: MetaAplicacao[];
  metasAplicacaoRecurso: MetaAplicacaoRecurso[];
  receitasDespesas: ReceitaDespesa[];
  equipamentos: Equipamento[];
};

const ShowPlanoDeTrabalho = ({
  descricao,
  metaFisica,
  metasAplicacoes,
  metasAplicacaoRecurso,
  receitasDespesas,
  equipamentos,
}: Props) => {
  const [tabPrincipalIndex, setPrincipalTabIndex] = useState(0);
  const passarPaginaTabPrincipal = (step: number = 1) => {
    setPrincipalTabIndex(tabPrincipalIndex + step);
  };
  const [tab2Index, set2TabIndex] = useState(0);
  const passarPaginaTab2 = (step: number = 1) => {
    set2TabIndex(tab2Index + step);
  };
  const [tab3Index, set3TabIndex] = useState(0);
  const passarPaginaTab3 = (step: number = 1) => {
    set3TabIndex(tab3Index + step);
  };

  return (
    <Tabs
      selectedIndex={tabPrincipalIndex}
      onSelect={(index) => setPrincipalTabIndex(index)}
    >
      <TabList>
        <Tab>1. Descrição</Tab>
        <Tab>2. Cronograma de Execução</Tab>
        <Tab>3. Plano de Aplicação</Tab>
        <Tab>4. Cronograma de Receita</Tab>
        <Tab>5. Cronograma de Despesa</Tab>
        <Tab>6. Aquisição de Equipamentos e Materiais Permanentes</Tab>
      </TabList>

      <TabPanel>
        <div>
          <Descricao
            passarPagina={() => {
              passarPaginaTabPrincipal();
            }}
            descricaoObj={descricao}
          />
        </div>
      </TabPanel>

      <TabPanel>
        <Tabs
          selectedIndex={tab2Index}
          onSelect={(index) => set2TabIndex(index)}
        >
          <TabList>
            <Tab>2.1. Cronograma de Execução Fisico</Tab>
            <Tab>2.2. Cronograma de Aplicação Financeira</Tab>
          </TabList>
          <TabPanel>
            <ExecucaoFisico
              listaMetas={metaFisica}
              passarPagina={() => {
                passarPaginaTab2();
              }}
              voltarPagina={() => passarPaginaTabPrincipal(-1)}
            />
          </TabPanel>
          <TabPanel>
            <AplicacaoFinanceira
              aplicacoesCapital={metasAplicacoes.filter(
                (e) => e.tipo == "capital"
              )}
              aplicacoesCorrente={metasAplicacoes.filter(
                (e) => e.tipo == "corrente"
              )}
              listaMetas={metaFisica}
              passarPagina={passarPaginaTabPrincipal}
              voltarPagina={() => passarPaginaTab2(-1)}
            />
          </TabPanel>
        </Tabs>
      </TabPanel>

      <TabPanel>
        <Tabs
          selectedIndex={tab3Index}
          onSelect={(index) => set3TabIndex(index)}
        >
          <TabList>
            <Tab>3.1. Manutenção Predial</Tab>
            <Tab>3.2. Material Permanente</Tab>
            <Tab>3.3. Material de Consumo</Tab>
            <Tab>3.4. Serviços de Terceiros (Pessoa Jurídica)</Tab>
          </TabList>
          <TabPanel>
            <form>
              <AplicacaoRecurso
                passarPagina={passarPaginaTab3}
                voltarPagina={() => passarPaginaTabPrincipal(-1)}
                listaAplicacoes={metasAplicacaoRecurso.filter(
                  (e) => e.tipo === "Manutenção Predial"
                )}
                title="3.1. Manutenção Predial:"
              />
            </form>
          </TabPanel>
          <TabPanel>
            <form>
              <AplicacaoRecurso
                passarPagina={passarPaginaTab3}
                voltarPagina={() => passarPaginaTab3(-1)}
                listaAplicacoes={metasAplicacaoRecurso.filter(
                  (e) => e.tipo === "Material Permanente"
                )}
                title="3.2. Material Permanente:"
              />
            </form>
          </TabPanel>
          <TabPanel>
            <form>
              <AplicacaoRecurso
                passarPagina={passarPaginaTab3}
                voltarPagina={() => passarPaginaTab3(-1)}
                listaAplicacoes={metasAplicacaoRecurso.filter(
                  (e) => e.tipo === "Material de Consumo"
                )}
                title="3.3. Material de Consumo:"
              />
            </form>
          </TabPanel>
          <TabPanel>
            <form>
              <AplicacaoRecurso
                passarPagina={passarPaginaTabPrincipal}
                voltarPagina={() => passarPaginaTab3(-1)}
                listaAplicacoes={metasAplicacaoRecurso.filter(
                  (e) => e.tipo === "Serviços de Terceiros"
                )}
                title="3.4. Serviços de Terceiros (Pessoa Jurídica)"
              />
            </form>
          </TabPanel>
        </Tabs>
      </TabPanel>

      <TabPanel>
        <form>
          <ReceitasDespesas
            passarPagina={passarPaginaTabPrincipal}
            voltarPagina={() => passarPaginaTabPrincipal(-1)}
            listaAplicacoesOSC={deconvertCalendario(
              receitasDespesas,
              "osc",
              "receita"
            )}
            listaAplicacoesOrgao={deconvertCalendario(
              receitasDespesas,
              "orgao",
              "receita"
            )}
            title={
              <>
                4. Cronograma de <strong>Receita</strong> :
              </>
            }
          />
        </form>
      </TabPanel>

      <TabPanel>
        <form>
          <ReceitasDespesas
            passarPagina={passarPaginaTabPrincipal}
            voltarPagina={() => passarPaginaTabPrincipal(-1)}
            listaAplicacoesOSC={deconvertCalendario(
              receitasDespesas,
              "osc",
              "despesa"
            )}
            listaAplicacoesOrgao={deconvertCalendario(
              receitasDespesas,
              "orgao",
              "despesa"
            )}
            title={
              <>
                5. Cronograma de <strong>Despesa</strong> :
              </>
            }
          />
        </form>
      </TabPanel>

      <TabPanel>
        <Equipamentos
          itens={equipamentos}
          voltarPagina={() => passarPaginaTabPrincipal(-1)}
          manutencao={descricao.manutencao_equipamentos}
        />
      </TabPanel>
    </Tabs>
  );
};
export default ShowPlanoDeTrabalho;
